@if(!templateForPermitForm){
<div class="application-required-documents">
  <div class="header">
    <h2>Required Documents</h2>
    <p *ngIf="applicationNumber" class="application-number">
      Application #{{ applicationNumber }}
    </p>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading required documents...</p>
  </div>

  <div *ngIf="!loading && documentEntities.length === 0" class="no-documents">
    <p>No required documents found for this application.</p>
  </div>

  <div
    *ngIf="!loading && documentEntities.length > 0"
    class="documents-container"
  >
    <div class="alert alert-info" *ngIf="hasIncompleteRequiredDocuments()">
      <strong>Note:</strong> Some required documents are missing. Please upload
      all required documents.
    </div>

    <div
      class="document-entity-group"
      *ngFor="let docEntity of documentEntities"
    >
      <div class="entity-header">
        <div class="entity-info">
          <h3 class="entity-label">
            {{ docEntity.label }}
            <span class="required-indicator" *ngIf="docEntity.isRequired"
              >*</span
            >
          </h3>
          <div class="entity-metadata">
            <span class="activity-name">{{ docEntity.activityName }}</span>
            <span
              class="status-badge"
              [ngClass]="getStatusClass(docEntity.activityStatus)"
            >
              {{ getStatusLabel(docEntity.activityStatus) }}
            </span>
            <span class="review-badge" *ngIf="docEntity.requireReview">
              Review Required
            </span>
          </div>
        </div>
        <div class="document-count">
          {{ docEntity.documentCount }} document(s)
        </div>
      </div>

      <div class="upload-section" *ngIf="docEntity.canUpload">
        <wm-upload
          [allowMultipleFiles]="true"
          [pathSegments]="getUploadPathSegments(docEntity)"
          [key]="getUploadKey(docEntity)"
          [buttonText]="'Upload Document(s)'"
          [previouslyUploadedFiles]="docEntity.documents || []"
          [showUploadedFilesList]="true"
          [showRemove]="true"
          [validDocumentTypes]="docEntity.validDocumentTypes || ''"
          [deleteStoredDocument]="false"
          (uploadComplete)="onUploadComplete($event, docEntity)"
          (fileDeleted)="onFileDeleted(docEntity, $event)"
        >
        </wm-upload>
      </div>

      <div
        class="uploaded-files-readonly"
        *ngIf="
          !docEntity.canUpload &&
          docEntity.documents &&
          docEntity.documents.length > 0
        "
      >
        <div class="document-item" *ngFor="let doc of docEntity.documents">
          <div class="document-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              ></path>
              <polyline points="14 2 14 8 20 8"></polyline>
            </svg>
          </div>
          <div class="document-name">
            <a [href]="doc.path" target="_blank">{{
              getDocumentFileName(doc)
            }}</a>
          </div>
        </div>
      </div>

      <div
        class="no-documents-message"
        *ngIf="
          docEntity.isRequired &&
          (!docEntity.documents || docEntity.documents.length === 0)
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        This required document has not been uploaded yet.
      </div>
    </div>

    <!-- Additional Documents Section (not tied to specific data entities) -->
    <div class="additional-documents-section">
      <div class="section-header">
        <h3>Additional Documents</h3>
        <p class="section-description">
          Upload any additional documents related to this application that are
          not required by specific workflow activities.
        </p>
      </div>

      <div class="upload-section">
        <wm-upload
          [allowMultipleFiles]="true"
          [pathSegments]="getGeneralUploadPathSegments()"
          [key]="getGeneralUploadKey()"
          [buttonText]="'Upload Additional Document(s)'"
          [previouslyUploadedFiles]="generalDocuments"
          [showUploadedFilesList]="true"
          [showRemove]="true"
          [deleteStoredDocument]="false"
          (uploadComplete)="onGeneralUploadComplete($event)"
          (fileDeleted)="onGeneralFileDeleted($event)"
        >
        </wm-upload>
      </div>

      <div class="document-count-info" *ngIf="generalDocuments.length > 0">
        <span class="material-icons">description</span>
        {{ generalDocuments.length }} additional document(s) uploaded
      </div>
    </div>

    <div class="actions">
      <button
        class="btn btn-primary btn-save"
        (click)="saveDocuments()"
        [disabled]="saving"
      >
        <span *ngIf="!saving">Save Documents</span>
        <span *ngIf="saving">
          <span class="spinner-small"></span>
          Saving...
        </span>
      </button>
    </div>
  </div>
</div>
}@else{
<div
  class="attachment-container"
  [ngClass]="{ 'staff-attachment-container': context?.janusLayout === 'staff' }"
>
  <div
    class="header-container"
    *ngIf="!loading"
    [style.backgroundColor]="
      context?.janusLayout === 'staff' ? 'none' : 'rgba(245, 245, 245, 1)'
    "
  >
    <wm-common-text
      [data]="{ text: 'Required Documents' }"
      class="header-text"
    ></wm-common-text>
    <wm-common-icon
      *ngIf="context.janusLayout === 'applicant'"
      class="close-btn"
      [data]="{ iconName: closeIcon }"
      (click)="closeOpenModal()"
    ></wm-common-icon>
    <wm-common-confirmation-modal
      #closeModal
      [data]="closeModalData"
      (onNoClick)="closeConfirmModal()"
      (onYesClick)="handleClose()"
    ></wm-common-confirmation-modal>
  </div>
  <div
    #attachmentContent
    class="attachment-content"
    [ngStyle]="{
      height: loading ? '545px' : 'auto'
    }"
    [ngClass]="{
      'require-document-content': !loading && documentEntities.length === 0
    }"
  >
    <div *ngIf="loading" class="loader-overlay">
      <div class="loader"></div>
    </div>

    <div
      class="require-document-container"
      *ngIf="!loading && hasMissingRequiredDocuments()"
      }
    >
      <wm-common-icon
        class="warning-icon"
        [data]="{ iconName: warningAmberIcon }"
      ></wm-common-icon>
      <wm-common-text
        class="require-document-text"
        [data]="{ text: requireDocumentWarningText }"
      ></wm-common-text>
    </div>
    <div
      class="document-entity-container"
      *ngFor="let docEntity of documentEntities"
      [ngClass]="{
        'required-doc-empty': docEntity.documents?.length > 0,
        'require-review':
          docEntity.requireReview && context.janusLayout === 'staff'
      }"
    >
      <div
        class="warning-require-content"
        *ngIf="
          docEntity.isRequired &&
          (context?.janusLayout !== 'staff' || !docEntity.requireReview) &&
          (!docEntity.documents || docEntity.documents.length === 0)
        "
      >
        <wm-common-icon
          class="warning-icon warning-color-icon"
          [data]="{ iconName: warningAmberIcon }"
        ></wm-common-icon>
        <wm-common-text
          [data]="{ text: warningRequireText }"
          class="warning-text"
        ></wm-common-text>
      </div>
      <div
        class="info-review-content"
        *ngIf="
          docEntity.requireReview &&
          context?.janusLayout === 'staff' &&
          (!docEntity.documents || docEntity.documents.length === 0)
        "
      >
        <wm-common-icon
          class=" info-icon"
          [data]="{ iconName: infoOutlinedIcon }"
        ></wm-common-icon>
        <wm-common-text
          [data]="{ text: reviewDocumentText }"
          class="info-text"
        ></wm-common-text>
      </div>

      <div class="entity-data">
        <div class="left-content">
          <div class="janus-label-content">
            <wm-common-text
              [data]="{ text: docEntity.label }"
              class="janus-entity-label"
            ></wm-common-text>
            <span class="required-indicator" *ngIf="docEntity.isRequired"
              >*</span
            >
          </div>
          <div class="status-content">
            <wm-common-text
              [data]="{ text: '|' }"
              class="entity-text"
            ></wm-common-text>
            <wm-common-text
              [data]="{ text: 'Form #' }"
              class="entity-text"
            ></wm-common-text>
            <wm-common-text
              [ngClass]="getStatusJanusClass(docEntity.activityStatus)"
              [data]="{ text: getStatusLabel(docEntity.activityStatus) }"
              class="entity-text"
            ></wm-common-text>
          </div>
        </div>
        <div class="right-content">
          <wm-common-text
            [data]="{text:`${docEntity.documentCount} document(s)`}"
            class="document-text"
          ></wm-common-text>
        </div>
      </div>
      <div *ngIf="docEntity.canUpload">
        <wm-upload
          [allowMultipleFiles]="true"
          [pathSegments]="getUploadPathSegments(docEntity)"
          [key]="getUploadKey(docEntity)"
          [buttonText]="'Upload Document(s)'"
          [previouslyUploadedFiles]="docEntity.documents || []"
          [showUploadedFilesList]="true"
          [showRemove]="true"
          [validDocumentTypes]="docEntity.validDocumentTypes || ''"
          [deleteStoredDocument]="false"
          (uploadComplete)="onUploadComplete($event, docEntity)"
          (fileDeleted)="onFileDeleted(docEntity, $event)"
          [documentCount]="docEntity.documentCount"
          [attachmentTemplate]="true"
          [requireReview]="docEntity.requireReview"
          [workflowApplicationDocumentId]="
            docEntity.workflowApplicationDocumentId
          "
          (reviewChanged)="onReviewChanged($event)"
          (hasUploadChanges)="hasUploadChanges = $event"
        >
        </wm-upload>
      </div>
      <div
        *ngIf="
          !docEntity.canUpload &&
          docEntity.documents &&
          docEntity.documents.length > 0
        "
      >
        <div class="doc-item" *ngFor="let doc of docEntity.documents">
          <wm-common-icon
            [data]="{ iconName: imageIcon }"
            class="image-icon"
          ></wm-common-icon>
          <a [href]="doc.path" target="_blank" class="attachment-underline">
            <wm-common-text
              [data]="{ text: getDocumentFileName(doc) }"
              class="file-name"
            ></wm-common-text
          ></a>
        </div>
      </div>
    </div>
    <div class="janus-additional-documents-container" *ngIf="!loading">
      <div class="additional-document-content">
        <wm-common-text
          [data]="{ text: additionalDocumentText }"
          class="additional-document-text"
        ></wm-common-text>
        <div class="document-content">
          <wm-common-text
            [data]="{text:`${generalDocuments.length} document(s)`}"
            class="document-text"
          ></wm-common-text>
        </div>
      </div>
      <wm-common-text
        [data]="{ text: additionalDocumentSubtext }"
        class="additional-document-subText"
      ></wm-common-text>
      <wm-upload
        [allowMultipleFiles]="true"
        [pathSegments]="getGeneralUploadPathSegments()"
        [key]="getGeneralUploadKey()"
        [buttonText]="'Upload Additional Document(s)'"
        [previouslyUploadedFiles]="generalDocuments"
        [showUploadedFilesList]="true"
        [showRemove]="true"
        [deleteStoredDocument]="false"
        (uploadComplete)="onGeneralUploadComplete($event)"
        (fileDeleted)="onGeneralFileDeleted($event)"
        [attachmentTemplate]="true"
        (reviewChanged)="onReviewChanged($event)"
        (hasUploadChanges)="hasUploadChanges = $event"
        [validDocumentTypes]="validGeneralDocumentTypes"
      >
      </wm-upload>
    </div>
  </div>
  <div class="save-content" *ngIf="!loading">
    <wm-common-button *ngIf="hasUploadChanges && !saving"
      [data]="{text:saving?'SAVING...':'SAVE',onClick:saveOpenModal.bind(this),disabled:!hasUploadChanges || saving}"
      class="save-button"
    >
    </wm-common-button>
    <wm-common-confirmation-modal
      #saveModal
      [data]="saveModalData"
      (onNoClick)="saveCloseModal()"
      (onYesClick)="saveJanusDocuments()"
    ></wm-common-confirmation-modal>
  </div>
</div>
}
